module.exports = __webpack_public_path__ + "static/eatbitterback-38d21763aa53fecba84a27cb1e494d3a.jpg";